export default function Divider({ text }: { text: string }) {
  return (
    <div className="relative my-5">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t-2 border-cd-purple" />
      </div>
      <div className="relative flex justify-center">
        <span className="bg-white px-2 text-lg font-semibold text-cd-purple">
          {text}
        </span>
      </div>
    </div>
  );
}
